import { render, staticRenderFns } from "./settings-organization-rate-card-custom-value.vue?vue&type=template&id=59d56ce8&scoped=true&"
import script from "./settings-organization-rate-card-custom-value.vue?vue&type=script&lang=js&"
export * from "./settings-organization-rate-card-custom-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d56ce8",
  null
  
)

export default component.exports